import React from 'react'
import { map } from 'lodash'

const TableCellList = ({ list }) => (
  <ul style={{ listStyle: 'none', margin: 0, padding: 0, fontSize: '13px' }}>
    {map(list, ({ label, value }) => (
      <li className='d-flex'>
        {label && <i style={{ paddingRight: '3px' }}>{label}:</i>}
        <span className='table-cell-strong'>{value}</span>
      </li>
    ))}
  </ul>
)

export default TableCellList
